import { Suspense } from 'react'
import { LoadBalancerSwitcherFallback } from '@/components/layout/breadcrumbs/load-balancer/load-balancer-switcher/fallback'
import { LoadBalancerSwitcherData } from '@/components/layout/breadcrumbs/load-balancer/load-balancer-switcher/switcher'

export const LoadBalancerSwitcher = () => (
  <Suspense fallback={<LoadBalancerSwitcherFallback />}>
    <LoadBalancerSwitcherData />
  </Suspense>
)
